import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class IfengVideo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return <div className={styles.contIntro} dangerouslySetInnerHTML={{ __html: content.productsLeft3 }} />;
    }
}

export default IfengVideo;
